import { createActions, createReducer } from 'reduxsauce'

import { AuthenticationTypes } from '../authentication/duckAuthentication'

/* Initial State */
const INITIAL_STATE = {
  error: null
}

/**
 * Creating actions and types with reduxsauce.
 */
const { Types, Creators } = createActions({
  saveRole: ['role', 'onSuccess', 'onError'],
  removeRole: ['role', 'onSuccess', 'onError'],
  saveFarmRole: ['role', 'onSuccess', 'onError'],
  removeFarmRole: ['role', 'onSuccess', 'onError'],
  saveFarmRoleModules: ['role', 'onSuccess', 'onError'],
  roleError: ['error']
})

const saveRole = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error
})

const removeRole = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error
})

const saveFarmRole = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error
})

const removeFarmRole = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error
})

const saveFarmRoleModules = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error
})

const roleError = (state = INITIAL_STATE, { error }) => ({
  ...state,
  error
})

const logout = () => ({ ...INITIAL_STATE })


/**
 * Creating reducer with Types.
 */
export default createReducer(INITIAL_STATE, {
  [Types.ROLE_ERROR]: roleError,

  [Types.SAVE_ROLE]: saveRole,
  [Types.REMOVE_ROLE]: removeRole,

  [Types.SAVE_FARM_ROLE]: saveFarmRole,
  [Types.REMOVE_FARM_ROLE]: removeFarmRole,
  [Types.SAVE_FARM_ROLE_MODULES]: saveFarmRoleModules,

  [AuthenticationTypes.LOGOUT]: logout
})

export {
  Types as RoleTypes,
  Creators as RoleActions
}
